// ServicesManagement.js (Main Wrapper Component)
import React, { useState } from "react";
import { Card, Tabs } from "antd";
import {
  DollarOutlined,
  UnorderedListOutlined,
  BarChartOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import CreateService from "./CreateService";
import ServicesList from "./ServiceList";
// import ServicesStatistics from "./ServicesStatistics";

function ServicesManagement() {
  const [activeTab, setActiveTab] = useState("create");
  const [refreshKey, setRefreshKey] = useState(0);

  const handleServiceCreated = () => {
    setActiveTab("list"); // Switch to manage services tab
  };

  const handleServiceUpdated = () => {
    // Trigger refresh in ServicesList
    setRefreshKey((prev) => prev + 1);
  };

  const tabItems = [
    {
      key: "create",
      label: (
        <span>
          <PlusOutlined />
          Create Service
        </span>
      ),
      children: <CreateService onServiceCreated={handleServiceCreated} />,
    },
    {
      key: "list",
      label: (
        <span>
          <UnorderedListOutlined />
          Manage Services
        </span>
      ),
      children: (
        <ServicesList
          key={refreshKey}
          isActive={activeTab === "list"}
          onServiceUpdated={handleServiceUpdated}
        />
      ),
    },
    // {
    //   key: "statistics",
    //   label: (
    //     <span>
    //       <BarChartOutlined />
    //       Statistics
    //     </span>
    //   ),
    //   children: <ServicesStatistics />,
    // },
  ];

  return (
    <div style={{ padding: "24px" }}>
      <Card
        title={
          <div style={{ display: "flex", alignItems: "center" }}>
            <DollarOutlined style={{ marginRight: "8px", color: "#f97316" }} />
            Services Management
          </div>
        }
      >
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={tabItems}
          size="large"
        />
      </Card>
    </div>
  );
}

export default ServicesManagement;
